
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("jYWuv", function(module, exports) {
globalThis.closeto = function closeto(left, right) {
    return Math.abs(left - right) < 0.02;
};

});

parcelRegister("8EoS4", function(module, exports) {
globalThis.Message = class Message {
    constructor(type, body, uid){
        this.type = type;
        this.body = body;
        if (uid) this.uid = uid;
    }
};

});

parcelRegister("4dS3o", function(module, exports) {
globalThis.PlayerUpdate = class PlayerUpdate {
    static from(player) {
        const update = Object.create(null);
        update.u = player.uid;
        update.i = player.index;
        update.x = player.position.x;
        update.y = player.position.y;
        update.d = player.direction;
        update.s = player.sprinting + 0;
        update.m = player.moving + 0;
        update.g = player.grounded + 0;
        update.f = player.floating + 0;
        return update;
    }
    apply(player) {
        player.uid = this.u;
        player.index = this.i;
        player.position.x = this.x;
        player.position.y = this.y;
        player.direction = this.d;
        player.sprinting = !!this.s;
        player.moving = !!this.m;
        player.grounded = !!this.g;
        player.floating = !!this.f;
    }
};

});

parcelRegister("g35pr", function(module, exports) {
globalThis.Time = class Time {
    constructor(ms){
        this.value = ms;
    }
    toString() {
        const hours = this.getHours().toString().padStart(2, "0");
        const minutes = this.getMinutes().toString().padStart(2, "0");
        const seconds = this.getSeconds().toString().padStart(2, "0");
        const millis = this.getMillis().toString().padStart(3, "0");
        return `${hours}:${minutes}:${seconds}.${millis}`;
    }
    getMillis() {
        return this.value % 1000;
    }
    getSeconds() {
        return Math.floor(this.value / 1000) % 60;
    }
    getMinutes() {
        return Math.floor(this.value / 1000 / 60) % 60;
    }
    getHours() {
        return Math.floor(this.value / 1000 / 60 / 60) % 24;
    }
};

});

parcelRegister("6NK9J", function(module, exports) {
globalThis.Vector2 = class Vector2 {
    constructor(x, y){
        this.x = x || 0;
        this.y = y || 0;
    }
    toString() {
        return `${this.x}x${this.y}`;
    }
    static fromString(str) {
        const [x, y] = str.split("x");
        return new Vector2(Number(x), Number(y));
    }
    clone() {
        return new Vector2(this.x, this.y);
    }
    apply(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    }
    distance(other) {
        const xdiff = this.x - other.x;
        const ydiff = this.y - other.y;
        return Math.sqrt(Math.pow(xdiff, 2) + Math.pow(ydiff, 2));
    }
    add(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    }
    sub(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    }
    mul(by) {
        this.x *= by;
        this.y *= by;
        return this;
    }
    div(by) {
        this.x /= by;
        this.y /= by;
        return this;
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    static sum(array) {
        const result = new Vector2();
        for (const vec of array)if (vec) result.add(vec);
        return result;
    }
    static avg(array) {
        const result = new Vector2();
        let count = 0;
        for (const vec of array)if (vec) {
            result.add(vec);
            count++;
        }
        if (count) result.div(count);
        return result;
    }
};

});

parcelRegister("Bemcv", function(module, exports) {
globalThis.HUB_ORIGIN = "https://platfo-hub.fly.dev";
globalThis.ANIMATION_STEP = 33;
globalThis.PHYSICS_STEP = 16;
globalThis.CARD_HEIGHT = 180;
globalThis.CARD_WIDTH = 240;
globalThis.DOUBLE_PRESS_TIMEOUT = 200;
globalThis.DRAG = 0.2;
globalThis.GRAVITY = 0.9;
globalThis.LOCK_DURATION = 3000;
globalThis.MAX_FALLING_SPEED = 15;
globalThis.SCALE_MAX = 1.5;
globalThis.SCALE_MIN = 0.5;
globalThis.SCALE_STEP = 0.1;
globalThis.TOPBAR_HEIGHT = 44;
globalThis.UNIT = 32;
globalThis.BASE64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
globalThis.PLAYER_ANIMATIONS = {
    STANDING: [
        new Vector2(0, 0)
    ],
    WALKING: [
        new Vector2(1, 0),
        new Vector2(2, 0),
        new Vector2(3, 0),
        new Vector2(4, 0),
        new Vector2(5, 0),
        new Vector2(6, 0)
    ],
    RUNNING: [
        new Vector2(1, 1),
        new Vector2(2, 1),
        new Vector2(3, 1),
        new Vector2(4, 1),
        new Vector2(5, 1),
        new Vector2(6, 1)
    ],
    JUMPING: [
        new Vector2(0, 2),
        new Vector2(1, 2),
        new Vector2(2, 2)
    ]
};
globalThis.PLAYER_ANIMATIONS.JUMPING.hanging = true;
globalThis.PLAYER_CONTROLS = [
    [
        37,
        40,
        38,
        39
    ],
    [
        65,
        83,
        87,
        68
    ],
    [
        74,
        75,
        73,
        76
    ]
];
globalThis.ICONS = {
    MENU: new Vector2(0, 0),
    CAMERA: new Vector2(1, 0),
    PEN: new Vector2(2, 0),
    DEBUG: new Vector2(3, 0),
    CAMERALOCK: new Vector2(4, 0)
};
globalThis.BLOCKS = 24;
globalThis.BLOCK_CONFIG = [
    {
        color: "black"
    },
    {
        color: "red"
    },
    {
        color: "green"
    },
    {
        color: "yellow"
    },
    {
        color: "blue"
    },
    {
        color: "magenta"
    },
    {
        color: "cyan"
    },
    {
        color: "white"
    },
    {
        passthrough: true,
        gravity: new Vector2()
    },
    {
        passthrough: true,
        gravity: new Vector2(-1.5, 0)
    },
    {
        passthrough: true,
        gravity: new Vector2(0, 1.5)
    },
    {
        passthrough: true,
        gravity: new Vector2(0, -1.5)
    },
    {
        passthrough: true,
        gravity: new Vector2(1.5, 0)
    },
    {
        passthrough: true,
        key: 1
    },
    {
        passthrough: true,
        key: 2
    },
    {
        passthrough: true,
        key: 3
    },
    {
        passthrough: true,
        start: true
    },
    {
        passthrough: true,
        finish: true
    },
    {
        passthrough: true,
        unlock: 1
    },
    {
        passthrough: true,
        unlock: 2
    },
    {
        passthrough: true,
        unlock: 3
    },
    {
        lock: 1
    },
    {
        lock: 2
    },
    {
        lock: 3
    }
];
globalThis.WORLD_SIZES = [
    "32x8",
    "16x16",
    "32x16",
    "64x16",
    "32x32",
    "64x32",
    "64x64",
    "96x32"
];

});

var $c59a082127ba0c46$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["bM2Tv","index.33d10550.js","6pFeU","worker.2643912a.js"]'));

parcelRequire("jYWuv");
parcelRequire("8EoS4");
parcelRequire("4dS3o");
parcelRequire("g35pr");
globalThis.uid = function uid() {
    let id = "";
    for(let i = 0; i < 24; i++)id += BASE64.charAt(Math.random() * 62);
    return id;
};


parcelRequire("6NK9J");
parcelRequire("Bemcv");
globalThis.Block = class Block {
    static of(index) {
        return new Block(0, 0, index);
    }
    constructor(x, y, index = 0){
        this.index = index;
        this.size = new Vector2(1, 1);
        this.position = new Vector2(x, y);
        this.div = document.createElement("div");
        this.div.classList.add("block");
        this.render();
    }
    remove() {
        this.div.remove();
    }
    update(update) {
        Object.assign(this, update);
        this.render();
    }
    render() {
        this.div.style.setProperty("--x", this.position.x);
        this.div.style.setProperty("--y", this.position.y);
        this.setSpritePosition(this.index % 8, Math.floor(this.index / 8));
    }
    setSpritePosition(x, y) {
        this.div.style.setProperty("--sprite-x", x);
        this.div.style.setProperty("--sprite-y", y);
    }
};


globalThis.Browser = class Browser {
    constructor(){
        document.title = "Platfo | Browser";
        document.body.id = "browser";
        this.abort = new AbortController();
        this.profile_editor = new ProfileEditor();
        this.local_worlds = new WorldList({
            title: "Local Saves",
            worlds: Object.values(globalThis.STORE.saves),
            control: [
                {
                    title: "New World",
                    onclick: ()=>globalThis.ROUTER.goto("/local/")
                }
            ]
        });
        document.body.append(this.profile_editor.div, this.local_worlds.div);
        addEventListener("store", this.onStore.bind(this), this.abort);
    }
    remove() {
        this.abort.abort();
        this.profile_editor.remove();
        this.local_worlds.remove();
        document.body.id = "";
    }
    onStore(event) {
        switch(event.detail){
            case "saves":
                this.local_worlds.setWorlds(Object.values(globalThis.STORE.saves));
                break;
        }
    }
};


globalThis.Camera = class Camera {
    constructor(){
        this.mousedown = false;
        this.startpos = null;
        this.startworldpos = null;
        this.abort = new AbortController();
        addEventListener("mousedown", this.onMousedown.bind(this), this.abort);
        addEventListener("mouseup", this.onMouseup.bind(this), this.abort);
        addEventListener("mousemove", this.onMousemove.bind(this), this.abort);
        document.addEventListener("wheel", this.onWheel.bind(this), this.abort);
        requestAnimationFrame(this.step.bind(this));
    }
    remove() {
        this.abort.abort();
    }
    onMousedown(event1) {
        if (!globalThis.TOPBAR.hasControl("camera")) return;
        this.mousedown = true;
        document.body.classList.add("grabbing");
        this.startpos = new Vector2(event1.clientX, event1.clientY);
        this.startworldpos = globalThis.WORLD.position.clone();
    }
    onMouseup() {
        if (!globalThis.TOPBAR.hasControl("camera")) return;
        document.body.classList.remove("grabbing");
        this.mousedown = false;
        this.startpos = null;
        this.startworldpos = null;
    }
    onMousemove() {
        if (!globalThis.TOPBAR.hasControl("camera")) return;
        if (!this.mousedown) return;
        const pos = new Vector2(event.clientX, event.clientY);
        const deltaworldpos = pos.clone().sub(this.startpos).div(globalThis.UNIT);
        const worldpos = deltaworldpos.clone().add(this.startworldpos);
        const { x: x, y: y } = worldpos;
        globalThis.WORLD.setPosition(x, y);
    }
    onWheel(event1) {
        if (!globalThis.TOPBAR.hasControl("camera")) return;
        const out = event1.deltaY > 0;
        if (out) globalThis.WORLD.decreaseScale();
        else globalThis.WORLD.increaseScale();
    }
    step() {
        if (this.abort.signal.aborted) return;
        requestAnimationFrame(this.step.bind(this));
        if (globalThis.TOPBAR.hasControl("camera")) return;
        if (globalThis.TOPBAR.hasState("cameralock")) return;
        if (!globalThis.WORLD.hasOwnPlayers()) return;
        const distance = globalThis.WORLD.getOwnPlayersDistance();
        const scale = 30 / distance;
        globalThis.WORLD.setScale(scale);
        const center = globalThis.WORLD.getOwnPlayersCenter();
        const { x: x, y: y } = center.sub(globalThis.WORLD.size.clone().div(2)).mul(globalThis.WORLD.scale);
        globalThis.WORLD.setPosition(-x, -y);
    }
};


globalThis.cancelbubble = function cancelbubble(event) {
    event.stopPropagation();
};


globalThis.Card = class Card {
    constructor(options = {}){
        this.abort = new AbortController();
        this.position = new Vector2();
        this.div = document.createElement("div");
        this.div.classList.add("card");
        this.bar = document.createElement("div");
        this.bar.classList.add("bar");
        this.div.append(this.bar);
        this.title = document.createElement("h3");
        this.title.classList.add("title");
        this.title.innerText = options.title || "Card";
        this.bar.append(this.title);
        if (options.closable !== false) {
            this.close = document.createElement("div");
            this.close.classList.add("close");
            this.bar.append(this.close);
            this.close.addEventListener("click", ()=>this.remove(), this.abort);
        }
        this.content = document.createElement("div");
        this.content.classList.add("content");
        this.div.append(this.content);
        document.body.append(this.div);
        this.mousedown = false;
        this.div.addEventListener("mousedown", this.onMousedown.bind(this), this.abort);
        this.bar.addEventListener("mousedown", this.onBarMousedown.bind(this), this.abort);
        addEventListener("mouseup", this.onMouseup.bind(this), this.abort);
        addEventListener("mousemove", this.onMousemove.bind(this), this.abort);
        this.setPosition(options.x ?? 100, options.y ?? 100);
        if (options.center || options.center_x) this.centerX();
        if (options.center || options.center_y) this.centerY();
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
    hide() {
        this.div.style.display = "none";
    }
    show() {
        this.div.style.display = "block";
        this.putOnTop();
    }
    onMousedown(event) {
        event.stopPropagation();
        this.putOnTop();
    }
    onBarMousedown(event) {
        this.mousedown = true;
        this.startcursorpos = new Vector2(event.clientX, event.clientY);
        this.startpos = this.position.clone();
    }
    onMouseup() {
        this.mousedown = false;
    }
    onMousemove(event) {
        if (!this.mousedown) return;
        const delta = new Vector2(event.clientX, event.clientY).sub(this.startcursorpos);
        const { x: x, y: y } = delta.clone().add(this.startpos);
        this.setPosition(x, y);
    }
    centerX() {
        const size = this.getSize();
        this.setPosition(innerWidth / 2 - size.x / 2, this.position.y);
    }
    centerY() {
        const size = this.getSize();
        this.setPosition(this.position.x, innerHeight / 2 - size.y / 2);
    }
    getSize() {
        const rect = this.div.getBoundingClientRect();
        return new Vector2(rect.right - rect.left, rect.bottom - rect.top);
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = Math.max(globalThis.TOPBAR_HEIGHT, y);
        this.renderPosition();
    }
    renderPosition() {
        this.div.style.setProperty("--x", this.position.x);
        this.div.style.setProperty("--y", this.position.y);
    }
    putOnTop() {
        const cards = document.body.getElementsByClassName("card");
        const last = cards[cards.length - 1];
        if (last !== this.div) last.after(this.div);
    }
};


globalThis.Chat = class Chat {
    constructor(){
        globalThis.CHAT = this;
        this.div = document.createElement("div");
        this.div.id = "chat";
        document.body.append(this.div);
    }
    remove() {
        this.div.remove();
        delete globalThis.CHAT;
    }
    push(msg, options = {}) {
        const div = document.createElement("div");
        div.innerText = msg;
        div.className = options.type || "";
        this.div.append(div);
    }
};


globalThis.Client = class Client {
    constructor(resource){
        globalThis.CLIENT = this;
        this.abort = new AbortController();
        this.server = new Server(resource);
        this.server.addEventListener("message", this.onMessage.bind(this), this.abort);
        this.server.addEventListener("close", this.onClose.bind(this), this.abort);
        if (this.server.open) this.onOpen();
        else this.server.addEventListener("open", this.onOpen.bind(this), this.abort);
    }
    remove() {
        this.abort.abort();
        this.server.remove();
        delete globalThis.CLIENT;
    }
    jump(index) {
        this.server.postMessage(new Message("jump", index));
    }
    move(index, direction, sprinting) {
        this.server.postMessage(new Message("move", {
            index: index,
            direction: direction,
            sprinting: sprinting
        }));
    }
    moveVertically(index, direction) {
        this.server.postMessage(new Message("movevertically", {
            index: index,
            direction: direction
        }));
    }
    addPlayer(index) {
        this.server.postMessage(new Message("addplayer", index));
    }
    removePlayer(index) {
        this.server.postMessage(new Message("removeplayer", index));
    }
    addBlock(x, y, index) {
        this.server.postMessage(new Message("addblock", {
            x: x,
            y: y,
            index: index
        }));
    }
    removeBlockAt(x, y) {
        this.server.postMessage(new Message("removeblock", {
            x: x,
            y: y
        }));
    }
    setWorldSize(x, y) {
        this.server.postMessage(new Message("setworldsize", {
            x: x,
            y: y
        }));
    }
    clearWorld() {
        this.server.postMessage(new Message("clearworld"));
    }
    loadWorld(data) {
        if (typeof data == "object") data = data.data;
        this.server.postMessage(new Message("loadworld", data));
    }
    onOpen() {
        const { profile: profile } = globalThis.STORE;
        this.server.postMessage(new Message("connect", {
            profile: profile
        }));
    }
    onClose() {
        new Dialogue({
            title: "Disconnected",
            body: "Connection has been closed.",
            closable: false,
            okText: "Exit",
            action: ()=>globalThis.ROUTER.goto("/"),
            center: true
        });
    }
    onMessage(event) {
        const { type: type, body: body } = event.data;
        switch(type){
            case "addconnection":
                globalThis.WORLD.connect(body);
                break;
            case "removeconnection":
                globalThis.WORLD.disconnect(body.id);
                break;
            case "block":
                globalThis.WORLD.updateBlock(body);
                break;
            case "player":
                globalThis.WORLD.updatePlayer(body);
                break;
            case "addplayer":
                globalThis.WORLD.addPlayer(...body);
                break;
            case "removeplayer":
                globalThis.WORLD.removePlayer(...body);
                break;
            case "addblock":
                globalThis.WORLD.addBlock(new Block(body.position.x, body.position.y, body.index));
                break;
            case "removeblock":
                globalThis.WORLD.removeAt(body.x, body.y);
                break;
            case "worldsize":
                globalThis.WORLD.setSize(body.x, body.y);
                break;
            case "chat":
                globalThis.CHAT.push(body.message, body);
                break;
            case "clear":
                dispatchEvent(new Event("worldclear"));
                break;
            case "loadstart":
                dispatchEvent(new Event("worldloadstart"));
                break;
            case "loadend":
                dispatchEvent(new Event("worldload"));
                break;
        }
    }
};


globalThis.ConnectionList = class ConnectionList {
    constructor(){
        this.abort = new AbortController();
        this.div = document.createElement("div");
        this.div.id = "connection-list";
        document.body.append(this.div);
        addEventListener("connections", this.update.bind(this), this.abort);
        this.update();
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
    update() {
        this.div.innerHTML = "";
        for (const profile of globalThis.WORLD.connections.values()){
            const div = document.createElement("div");
            div.innerText = profile.name;
            this.div.append(div);
        }
    }
};


globalThis.Dialogue = class Dialogue extends Card {
    constructor(options = {}){
        options.title = options.title || "Confirmation";
        super(options);
        globalThis.DIALOGUE?.remove();
        globalThis.DIALOGUE = this;
        this.action = options.action;
        this.div.classList.add("dialogue");
        this.body = document.createElement("p");
        this.body.innerText = options.body ?? "Are you sure?";
        const buttons = document.createElement("div");
        if (options.closable !== false) {
            this.cancel = document.createElement("button");
            this.cancel.classList.add("cancel");
            this.cancel.innerText = options.cancelText || "Cancel";
            this.cancel.addEventListener("click", this.remove.bind(this), this.abort);
            buttons.append(this.cancel);
        }
        this.ok = document.createElement("button");
        this.ok.classList.add("ok");
        this.ok.innerText = options.okText || "OK";
        this.ok.addEventListener("click", this.onOK.bind(this), this.abort);
        buttons.append(this.ok);
        this.content.append(this.body, buttons);
        addEventListener("keydown", this.onKeydown.bind(this), this.abort);
    }
    remove() {
        super.remove();
        delete globalThis.DIALOGUE;
    }
    onOK() {
        if (this.action) this.action.call(this) || this.remove();
        else this.remove();
    }
    onKeydown(event) {
        if (event.keyCode === 27) this.remove();
    }
};


globalThis.Game = class Game {
    constructor(_, context, id){
        globalThis.GAME = this;
        this.context = context;
        this.id = id;
        this.abort = new AbortController();
        this.client = new Client([
            "ws",
            "wss"
        ].includes(context) ? new URL(`${context}://${id}`) : null);
        this.world = new World();
        this.topbar = new Topbar();
        this.menu = new Menu();
        this.connection_list = new ConnectionList();
        this.chat = new Chat();
        this.status = new Status();
        this.camera = new Camera();
        this.pen = new Pen();
        document.body.style.overflow = "hidden";
        addEventListener("contextmenu", preventdefault, this.abort);
        if (this.client.server.open) this.onOpen();
        else this.client.server.addEventListener("open", this.onOpen.bind(this), this.abort);
    }
    remove() {
        document.body.style.overflow = "";
        this.abort.abort();
        this.client.remove();
        this.topbar.remove();
        this.menu.remove();
        this.connection_list.remove();
        this.chat.remove();
        this.status.remove();
        this.camera.remove();
        this.pen.remove();
        this.world.remove();
        delete globalThis.GAME;
    }
    onOpen() {
        if (this.context === "local") {
            if (this.id) globalThis.STORE.loadWorldFromSave(this.id);
        }
    }
};


globalThis.Icon = class Icon {
    constructor(name){
        this.div = document.createElement("div");
        this.div.classList.add("icon");
        this.setByName(name);
    }
    setByName(name) {
        const icon = globalThis.ICONS[name];
        if (!icon) return;
        this.setSpritePosition(icon.x, icon.y);
    }
    setSpritePosition(x, y) {
        this.div.style.setProperty("--sprite-x", x);
        this.div.style.setProperty("--sprite-y", y);
    }
};


globalThis.Menu = class Menu {
    constructor(){
        this.abort = new AbortController();
        this.div = document.createElement("div");
        this.div.id = "menu";
        this.buttons = {};
        this.constructButton("New", this.onNew.bind(this));
        this.constructButton("Save", this.onSave.bind(this));
        this.constructButton("Save As...", this.onSaveAs.bind(this));
        this.constructButton("Open...", this.onOpen.bind(this));
        this.div.append(document.createElement("div"));
        this.constructButton("Change Size...", this.onSize.bind(this), this.abort);
        this.constructButton("Clear", this.onClear.bind(this), this.abort);
        this.div.append(document.createElement("div"));
        this.constructButton("Exit", this.onExit.bind(this), this.abort);
        this.div.addEventListener("mousedown", cancelbubble, this.abort);
        addEventListener("mousedown", this.deactivate.bind(this), this.abort);
        addEventListener("addcontrol", this.onControl.bind(this), this.abort);
        addEventListener("removecontrol", this.onControl.bind(this), this.abort);
        addEventListener("store", this.update.bind(this), this.abort);
        this.hide();
        document.body.append(this.div);
        this.update();
    }
    constructButton(label, action) {
        const id = label.toLowerCase().replaceAll(/[ .]/g, "");
        const button = document.createElement("button");
        button.innerText = label;
        button.addEventListener("click", ()=>{
            this.deactivate();
            if (action) action();
        }, this.abort);
        this.div.append(this.buttons[id] = button);
    }
    update() {
        const { saves: saves } = globalThis.STORE;
        const { context: context } = globalThis.GAME;
        this.buttons.save.disabled = !globalThis.GAME.id || context !== "local";
        this.buttons.open.disabled = !!saves.length;
    }
    onControl(event) {
        if (event.detail !== "menu") return;
        if (this.isActive()) this.show();
        else this.hide();
    }
    onNew() {
        globalThis.ROUTER.goto("/local/");
    }
    onClear() {
        globalThis.CLIENT.clearWorld();
    }
    onSave() {
        globalThis.STORE.saveWorld();
    }
    onSaveAs() {
        new SaveForm();
    }
    onOpen() {
        new ListDialogue({
            title: "Open Save",
            options: Object.keys(globalThis.STORE.saves),
            action () {
                if (!this.selected) return true;
                if (globalThis.GAME.context === "local") globalThis.ROUTER.goto(`/local/${this.selected}`);
                else globalThis.STORE.loadWorldFromSave(this.selected);
            }
        });
    }
    onSize() {
        new ListDialogue({
            title: "Change World Size",
            options: globalThis.WORLD_SIZES,
            action () {
                if (!this.selected) return true;
                const { x: x, y: y } = Vector2.fromString(this.selected);
                globalThis.CLIENT.setWorldSize(x, y);
            }
        });
    }
    onExit() {
        globalThis.ROUTER.goto("/");
    }
    isActive() {
        return globalThis.TOPBAR.hasControl("menu");
    }
    deactivate() {
        globalThis.TOPBAR.removeControl("menu");
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
    hide() {
        this.div.style.display = "none";
    }
    show() {
        this.div.style.display = "";
    }
};


globalThis.NotFound = class NotFound {
    constructor(){
        document.title = "Platfo | Not Found";
        document.body.innerHTML = `
      <center>
        <h1>Resource Not Found</h1>
        <p>Click <a href="/">here</a> to go back to browser.</p>
      </center>
    `;
    }
    remove() {
        document.body.innerHTML = "";
    }
};


globalThis.Pagination = class Pagination {
    constructor(){
        this.abort = new AbortController();
        this.div = document.createElement("div");
        this.div.classList.add("pagination");
        this.pages = 1;
        this.active = 0;
        this.buttons = [];
        this.setPages(this.pages);
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
    setPages(pages) {
        this.pages = pages;
        this.active = Math.max(Math.min(this.active, this.pages - 1), 0);
        this.removeButtons();
        this.createButtons();
        this.renderActive();
    }
    setActive(detail) {
        this.active = detail;
        this.renderActive();
        this.div.dispatchEvent(new CustomEvent("active", {
            detail: detail
        }));
    }
    removeButtons() {
        this.div.innerHTML = "";
        this.buttons = [];
    }
    createButtons() {
        if (this.pages === 1) return;
        for (const i of this.getShowPages()){
            const button = document.createElement("button");
            if (i == null) button.classList.add("null");
            else button.innerText = i + 1;
            button.addEventListener("click", ()=>this.setActive(i), this.abort);
            button._index = i;
            this.buttons.push(button);
            this.div.append(button);
        }
    }
    getShowPages() {
        const indexes = [];
        const add = (i)=>indexes.includes(i) || indexes.push(i);
        if (this.pages <= 9) for(let i = 0; i < this.pages; i++)add(i);
        else {
            add(0);
            add(1);
            if (this.active > 3) indexes.push(null);
            if (this.active) add(this.active - 1);
            add(this.active);
            if (this.active < this.pages - 1) add(this.active + 1);
            if (this.active < this.pages - 4) indexes.push(null);
            add(this.pages - 2);
            add(this.pages - 1);
        }
        return indexes;
    }
    renderActive() {
        for (const button of this.buttons)if (this.active === button._index) button.classList.add("active");
        else button.classList.remove("active");
    }
};


globalThis.Pen = class Pen {
    constructor(){
        this.mouse0down = false;
        this.mouse2down = false;
        this.clientX = 0;
        this.clientY = 0;
        this.cursorX = 0;
        this.cursorY = 0;
        this.cursor = document.createElement("div");
        this.cursor.id = "cursor";
        globalThis.WORLD.div.append(this.cursor);
        this.abort = new AbortController();
        globalThis.WORLD.div.addEventListener("mousedown", this.onMousedown.bind(this), this.abort);
        addEventListener("mouseup", this.onMouseup.bind(this), this.abort);
        addEventListener("mousemove", this.onMousemove.bind(this), this.abort);
        addEventListener("addcontrol", this.onControl.bind(this), this.abort);
        addEventListener("removecontrol", this.onControl.bind(this), this.abort);
        this.selector = new BlockSelector();
        this.selector.hide();
    }
    remove() {
        this.abort.abort();
        this.selector.remove();
    }
    onControl(event) {
        if (event.detail !== "pen") return;
        if (this.isActive()) this.selector.show();
        else this.selector.hide();
    }
    isActive() {
        return globalThis.TOPBAR.hasControl("pen");
    }
    onMousedown(event) {
        if (!this.isActive()) return;
        if (event.button === 0) {
            this.mouse0down = true;
            this.placeBlockAtCursor();
        } else if (event.button === 2) {
            this.mouse2down = true;
            this.removeBlockAtCursor();
        }
    }
    onMouseup(event) {
        if (!this.isActive()) return;
        if (event.button === 0) this.mouse0down = false;
        else if (event.button === 2) this.mouse2down = false;
    }
    onMousemove(event) {
        if (!this.isActive()) return;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
        const { x: x, y: y } = this.getWorldPosition();
        this.cursorX = x;
        this.cursorY = y;
        this.setCursorPosition(x, y);
        if (this.mouse0down) this.placeBlockAtCursor();
        else if (this.mouse2down) this.removeBlockAtCursor();
    }
    getWorldPosition() {
        const rect = globalThis.WORLD.div.getBoundingClientRect();
        const x = this.clientX - rect.left;
        const y = this.clientY - rect.top;
        const result = new Vector2(x, y).div(globalThis.UNIT).div(globalThis.WORLD.scale).sub(new Vector2(1, 1)).floor();
        result.x = Math.max(-1, Math.min(result.x, globalThis.WORLD.size.x));
        result.y = Math.max(-1, Math.min(result.y, globalThis.WORLD.size.y));
        return result;
    }
    setCursorPosition(x, y) {
        this.cursor.style.setProperty("--x", x);
        this.cursor.style.setProperty("--y", y);
    }
    placeBlockAtCursor() {
        globalThis.CLIENT.addBlock(this.cursorX, this.cursorY, this.selector.index);
    }
    removeBlockAtCursor() {
        globalThis.CLIENT.removeBlockAt(this.cursorX, this.cursorY);
    }
};


globalThis.PlayerAnimator = class PlayerAnimator {
    constructor(player){
        this.player = player;
        this.current = "STANDING";
        this.step = 0;
        this.interval = setInterval(this.animate.bind(this), globalThis.ANIMATION_STEP);
    }
    remove() {
        clearInterval(this.interval);
    }
    animate() {
        if (this.player.frozen) return;
        this.updateAnimName();
        const animation = globalThis.PLAYER_ANIMATIONS[this.current];
        if (!animation) return;
        this.step++;
        if (!animation.hanging) this.step %= animation.length;
        else this.step = Math.min(this.step, animation.length - 1);
        const frame = animation[this.step];
        this.player.setSpritePosition(frame.x, frame.y);
    }
    updateAnimName() {
        if (this.player.floating) this.current = "JUMPING";
        else if (this.player.grounded) {
            if (this.player.moving) this.current = this.player.sprinting ? "RUNNING" : "WALKING";
            else this.current = "STANDING";
        } else this.current = "JUMPING";
        this.player.setDebugBottom(this.player.grounded);
        this.player.setDebugTop(this.player.roofed);
        this.player.setDebugLeft(this.player.left_walled);
        this.player.setDebugRight(this.player.right_walled);
    }
};


globalThis.PlayerConfiguration = class PlayerConfiguration {
    constructor(){
        this.index = 0;
    }
    static ofKeys(left, down, up, right, index) {
        const config = new PlayerConfiguration();
        config.left_key = left;
        config.down_key = down;
        config.up_key = up;
        config.right_key = right;
        config.index = index || 0;
        return config;
    }
};


globalThis.PlayerController = class PlayerController {
    constructor(player){
        this.player = player;
        this.config = player.config;
        this.keys = [];
        this.last_key = 0;
        this.last_key_time = 0;
        this.abort = new AbortController();
        addEventListener("keydown", this.onKeydown.bind(this), this.abort);
        addEventListener("keyup", this.onKeyup.bind(this), this.abort);
    }
    remove() {
        this.abort.abort();
    }
    onKeydown(event) {
        if (this.keys[event.keyCode]) return;
        this.keys[event.keyCode] = true;
        const time_since = Date.now() - this.last_key_time;
        const double = this.last_key === event.keyCode && time_since < globalThis.DOUBLE_PRESS_TIMEOUT;
        this.last_key = event.keyCode;
        this.last_key_time = Date.now();
        switch(event.keyCode){
            case this.config.left_key:
            case this.config.right_key:
                this.applyMovement(double);
                break;
            case this.config.up_key:
                if (this.player.floating) this.applyVerticalMovement();
                else this.player.jump();
                break;
            case this.config.down_key:
                this.applyVerticalMovement();
                break;
        }
    }
    onKeyup(event) {
        delete this.keys[event.keyCode];
        switch(event.keyCode){
            case this.config.left_key:
            case this.config.right_key:
                this.applyMovement();
                break;
            case this.config.up_key:
            case this.config.down_key:
                this.applyVerticalMovement();
                break;
        }
    }
    applyMovement(sprinting) {
        this.player.move(this.getDirection(), sprinting);
    }
    applyVerticalMovement() {
        this.player.moveVertically(this.getVerticalDirection());
    }
    getDirection() {
        return (this.keys[this.config.right_key] || 0) - (this.keys[this.config.left_key] || 0);
    }
    getVerticalDirection() {
        return (this.keys[this.config.down_key] || 0) - (this.keys[this.config.up_key] || 0);
    }
};


globalThis.Player = class Player {
    constructor(config){
        this.config = config;
        this.index = config.index;
        this.sprinting = false;
        this.left_walled = false;
        this.right_walled = false;
        this.grounded = false;
        this.floating = false;
        this.moving = false;
        this.direction = 1;
        this.position = new Vector2();
        this.div = document.createElement("div");
        this.div.classList.add("player", "color" + this.index);
        this.label = document.createElement("label");
        this.div.append(this.label);
        if (config.remote) this.div.classList.add("remote");
        else this.controller = new PlayerController(this);
        this.animator = new PlayerAnimator(this);
    }
    remove() {
        this.div.remove();
        this.controller?.remove();
        this.animator.remove();
    }
    update(update) {
        PlayerUpdate.prototype.apply.call(update, this);
        this.render();
    }
    jump() {
        globalThis.CLIENT.jump(this.index);
    }
    move(direction, sprinting) {
        globalThis.CLIENT.move(this.index, direction, sprinting);
    }
    moveVertically(direction) {
        globalThis.CLIENT.moveVertically(this.index, direction);
    }
    render() {
        const num = "\u2070\xb9\xb2\xb3\u2074\u2075\u2076\u2077\u2078\u2079"[this.index];
        this.label.innerText = `${this.name || "Player"}${num}`;
        this.div.style.setProperty("--x", this.position.x);
        this.div.style.setProperty("--y", this.position.y);
        this.div.style.setProperty("--direction", this.direction);
    }
    setSpritePosition(x, y) {
        this.div.style.setProperty("--sprite-x", x);
        this.div.style.setProperty("--sprite-y", y);
    }
    setDebugLeft(enabled) {
        if (enabled) this.div.classList.add("left");
        else this.div.classList.remove("left");
    }
    setDebugRight(enabled) {
        if (enabled) this.div.classList.add("right");
        else this.div.classList.remove("right");
    }
    setDebugBottom(enabled) {
        if (enabled) this.div.classList.add("bottom");
        else this.div.classList.remove("bottom");
    }
    setDebugTop(enabled) {
        if (enabled) this.div.classList.add("top");
        else this.div.classList.remove("top");
    }
    isCenterInScope(border = 0) {
        const rect = this.div.getBoundingClientRect();
        const clientX = (rect.left + rect.right) / 2;
        const clientY = (rect.top + rect.bottom) / 2;
        return clientX > innerWidth * border && clientX < innerWidth * (1 - border) && clientY > innerHeight * border && clientY < innerHeight * (1 - border);
    }
};


globalThis.preventdefault = function preventdefault(event) {
    event.preventDefault();
};


globalThis.ProfileEditor = class ProfileEditor {
    constructor(){
        this.abort = new AbortController();
        this.div = document.createElement("div");
        this.div.id = "profile-editor";
        this.icon = document.createElement("div");
        this.icon.classList.add("player", "remote");
        this.body = document.createElement("div");
        this.body.classList.add("body");
        this.name = document.createElement("input");
        this.id = document.createElement("small");
        this.body.append(this.name, this.id);
        this.div.append(this.icon, this.body);
        this.name.addEventListener("blur", this.onBlur.bind(this), this.abort);
        this.name.addEventListener("keydown", this.onKey.bind(this), this.abort);
        addEventListener("store", this.onStore.bind(this), this.abort);
        this.update();
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
    onBlur() {
        if (this.name.value) {
            globalThis.STORE.profile.name = this.name.value;
            globalThis.STORE.saveProp("profile");
        }
        this.update();
    }
    onKey(event) {
        if ([
            13,
            27
        ].includes(event.keyCode)) this.name.blur();
        else this.name.value = this.name.value.substring(0, 16);
    }
    onStore(event) {
        if (event.detail === "profile") this.update();
    }
    update() {
        this.name.value = globalThis.STORE.profile.name;
        this.id.innerText = globalThis.STORE.profile.id;
    }
};


globalThis.Profile = class Profile {
    constructor(data = {}){
        Object.assign(this, data);
        this.name = this.name || "Player";
        this.id = this.id || uid();
    }
};


globalThis.Router = class Router {
    constructor(pages){
        globalThis.ROUTER = this;
        this.abort = new AbortController();
        this.pages = pages;
        this.current = null;
        addEventListener("popstate", this.update.bind(this), this.abort);
        this.update();
    }
    goto(path) {
        history.pushState({}, "Platfo", path);
        this.update();
    }
    remove() {
        this.abort.abort();
        this.current.remove();
        delete globalThis.ROUTER;
    }
    update() {
        this.current?.remove();
        scrollTo(0, 0);
        for (const [pattern, Page] of Object.entries(this.pages)){
            const match = this.matches(pattern);
            if (!match) continue;
            this.current = new Page(...match);
            return;
        }
        this.current = new NotFound();
        dispatchEvent(new Event("route"));
    }
    matches(pattern) {
        const re = new RegExp(pattern);
        return re.exec(decodeURI(location.pathname));
    }
};


var $0b57ebceb6cbe4a2$exports = {};
$0b57ebceb6cbe4a2$exports = new URL("worker.2643912a.js", import.meta.url).toString();


globalThis.Server = class Server extends EventTarget {
    constructor(resource){
        super();
        this.abort = new AbortController();
        if (!resource) {
            const worker_url = new URL($0b57ebceb6cbe4a2$exports);
            this.worker = new Worker(worker_url, {
                type: "module"
            });
            this.addEventListener = this.worker.addEventListener.bind(this.worker);
            this.postMessage = this.worker.postMessage.bind(this.worker);
            this.onOpen();
        } else if (resource instanceof URL) {
            this.socket = new WebSocket(resource);
            this.socket.addEventListener("open", this.onOpen.bind(this));
            this.socket.addEventListener("close", this.onClose.bind(this));
            this.socket.addEventListener("message", this.onMessage.bind(this), this.abort);
        }
    }
    remove() {
        this.abort.abort();
        this.worker?.terminate();
        this.socket?.close();
    }
    onOpen() {
        this.open = true;
        this.dispatchEvent(new Event("open"));
    }
    onClose() {
        this.dispatchEvent(new Event("close"));
    }
    onMessage({ data: data }) {
        const event = new Event("message");
        event.data = JSON.parse(data);
        this.dispatchEvent(event);
    }
    postMessage(msg) {
        if (this.socket.readyState !== 1) return;
        this.socket.send(JSON.stringify(msg));
    }
};


globalThis.Store = class Store {
    constructor(){
        globalThis.STORE = this;
        this.loadSaves();
        this.loadProfile();
        this.loadProp("cameralock", false);
        this.loadProp("debug", false);
    }
    remove() {
        delete globalThis.STORE;
    }
    deleteWorld(name) {
        delete this.saves[name];
        this.saveProp("saves");
        dispatchEvent(new CustomEvent("store", {
            detail: "saves"
        }));
    }
    saveWorld() {
        if (!globalThis.GAME.id) return;
        this.saveWorldAs(globalThis.GAME.id);
    }
    saveWorldAs(name) {
        this.saves[name] = new WorldDocument(globalThis.WORLD.toBase64());
        this.saves[name].name = name;
        this.saveProp("saves");
        dispatchEvent(new CustomEvent("store", {
            detail: "saves"
        }));
    }
    loadWorldFromSave(name) {
        if (!this.saves[name]) return;
        globalThis.CLIENT.loadWorld(this.saves[name].data);
    }
    setProp(detail, value) {
        this[detail] = value;
        this.saveProp(detail);
        dispatchEvent(new CustomEvent("store", {
            detail: detail
        }));
    }
    saveProp(prop) {
        localStorage.setItem(prop, JSON.stringify(this[prop]));
    }
    loadProp(detail, fallback = null) {
        const data = localStorage.getItem(detail);
        if (data == null) {
            this[detail] = fallback;
            dispatchEvent(new CustomEvent("store", {
                detail: detail
            }));
            return this[detail];
        }
        try {
            const object = JSON.parse(data);
            this[detail] = object;
            dispatchEvent(new CustomEvent("store", {
                detail: detail
            }));
            return this[detail];
        } catch (error) {
            console.error(error);
            localStorage.removeItem(detail);
        }
    }
    loadSaves() {
        this.loadProp("saves", {});
        this.saves = Object.assign({
            Tutorial: null
        }, this.saves);
        this.saves.Tutorial = new WorldDocument(globalThis.TUTORIAL);
        for (const [key, save] of Object.entries(this.saves)){
            this.saves[key] = new WorldDocument(save);
            this.saves[key].name = key;
        }
        this.saveProp("saves");
    }
    loadProfile() {
        this.loadProp("profile", new Profile());
        this.profile = new Profile(this.profile);
        this.saveProp("profile");
    }
};


globalThis.TUTORIAL = `
HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH
HIIIIIIIIIIIIIIIIIIIII                                           H
HIIIIIIIIIIIIIIHHIIIIII           II                       II    H
HIIHHIIIIIIIIIIHHIIIIII  III     IIIIIII        III      IIII    H
HIIHHIIIIIIIIIIIIIIIIII IIIIIII IIIIIIII III   IIII      III     H
HIIIIIIIIRRIIIIIIIIIII  IIIIII   IIIIIII IIII  I                 H
HIIIIIIIIRRIIIIIIII      IIII      II    IIII    F    F          H
HIIIIIIIIHH                I                     F   LF  F       H
HIIIIIIIIHH                                      F    F  F       H
H                                        EEEEEEEEFFFFFFFFFEEEEEEIE
H                                        E                     EIE
H               CCCCCI          P        E                      IE
H               CMMKC      IDDDDDDI      E                       E
H               CLCKC      IDDDDDDI      E                       E
H  Q            CLCKCLCI   IDDDDDDI      X   LEEL  EEEEEEI EI  EEE
H          B     LCKCLC     DDDDDD       X    EE   EEEEEE  E   EEE
H       B  B    CCCMMLC     DDDDDD       X    EE   EEEEEE  E   EEE
HHHHHHHHBBBBHHHHCCCCCCCHHHHHDDDDDDHHHHHHHEEEEEEEEEEEEEEEEEEEEEEEEE
`.trim();


globalThis.WorldDocument = class WorldDocument {
    constructor(data){
        if (typeof data === "string") this.world = data;
        else if (typeof data === "object") Object.assign(this, data);
        if (!this.data) this.data = this.world || "AAA\nA A\nAAA";
        delete this.world;
    }
    getSize() {
        const rows = this.data.split("\n");
        const y = rows.length - 2;
        let x = 0;
        for (const row of rows)x = Math.max(x, row.length - 2);
        return new Vector2(x, y);
    }
};


globalThis.WorldListItem = class WorldListItem {
    constructor(world){
        const { name: name, host: host } = world;
        const size = world.getSize();
        this.abort = new AbortController();
        this.div = document.createElement("div");
        this.div.classList.add("world-list-item");
        this.div.innerHTML = `
      <div class="thumbnail"></div>
      <h3>${name}</h3>
      <div class="footer">
        <small>${size}</small>
        <div class="control"></div>
      </div>
    `;
        this.div.querySelector(".thumbnail").append(new WorldThumbnail(world).canvas);
        this.control = this.div.querySelector(".control");
        if (!host) {
            this.delete = document.createElement("button");
            this.delete.className = "delete";
            this.delete.innerText = "Delete";
            this.control.append(this.delete);
            this.delete.addEventListener("click", ()=>new Dialogue({
                    center_x: true,
                    body: `Are you sure you want to delete save "${name}"?`,
                    action: ()=>globalThis.STORE.deleteWorld(name)
                }), this.abort);
        }
        this.play = document.createElement("button");
        this.play.className = "play";
        this.play.innerText = "Play";
        this.control.append(this.play);
        this.play.addEventListener("click", ()=>{
            if (host) {
                if (host.startsWith("localhost")) globalThis.ROUTER.goto(`/ws/${host}`);
                else globalThis.ROUTER.goto(`/wss/${host}`);
            } else globalThis.ROUTER.goto(`/local/${name}`);
        }, this.abort);
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
};


globalThis.WorldList = class WorldList {
    constructor(options){
        this.worlds = options.worlds || [];
        this.abort = new AbortController();
        this.items = [];
        this.page_size = options.page_size || 3;
        this.div = document.createElement("div");
        this.div.classList.add("world-list");
        this.div.innerHTML = `
      <h2>
        <span>${options.title || "World List"}</span>
        <div class="control"></div>
      </h2>
      <div class="body"></div>
    `;
        this.control = this.div.querySelector(".control");
        this.body = this.div.querySelector(".body");
        for (const { title: title, onclick: onclick } of options.control || []){
            const button = document.createElement("button");
            button.innerText = title;
            button.addEventListener("click", onclick, this.abort);
            this.control.append(button);
        }
        this.pagination = new Pagination();
        this.pagination.div.addEventListener("active", this.updatePage.bind(this), this.abort);
        this.div.append(this.pagination.div);
        this.updatePage();
    }
    remove() {
        this.abort.abort();
        this.pagination.remove();
        this.removeCards();
        this.div.remove();
    }
    setWorlds(worlds) {
        this.worlds = worlds;
        this.updatePage();
    }
    updatePage() {
        const pages = Math.ceil(this.worlds.length / this.page_size);
        this.pagination.setPages(pages);
        this.removeCards();
        this.createCards();
    }
    removeCards() {
        for (const item of this.items)item.remove();
        this.items = [];
    }
    createCards() {
        const start = this.pagination.active * this.page_size;
        const end = start + this.page_size;
        const list = this.worlds.slice(start, end);
        for (const world of list){
            const item = new WorldListItem(world);
            this.items.push(item);
            this.body.append(item.div);
        }
    }
};


globalThis.WorldThumbnail = class WorldThumbnail {
    constructor(doc){
        this.canvas = document.createElement("canvas");
        const size = doc.getSize();
        this.canvas.style.transform = "scale(2)";
        this.canvas.width = size.x + 2;
        this.canvas.height = size.y + 2;
        this.context = this.canvas.getContext("2d");
        const base64 = globalThis.BASE64.split("");
        const rows = doc.data.split("\n");
        for(let y = 0; y < rows.length; y++){
            const row = rows[y];
            for(let x = 0; x < row.length; x++){
                const char = row[x];
                const index = base64.findIndex((c)=>c === char);
                if (index === -1) this.context.fillStyle = "#888";
                else {
                    const { passthrough: passthrough, color: color } = globalThis.BLOCK_CONFIG[index] || {};
                    this.context.fillStyle = color || (passthrough ? "#666" : "#000");
                }
                this.context.fillRect(x, y, 1, 1);
            }
        }
    }
};


globalThis.World = class World {
    constructor(){
        globalThis.WORLD = this;
        this.players = new Map();
        this.connections = new Map();
        this.loading = false;
        this.position = new Vector2();
        this.size = new Vector2();
        this.scale = 1;
        this.div = document.createElement("div");
        this.div.id = "world";
        document.body.append(this.div);
        this.setScale(0.5);
        this.setSize(16, 16);
        this.setPosition(0, 0);
    }
    remove() {
        this.removeAllPlayers();
        this.clear();
        this.div.remove();
        delete globalThis.WORLD;
    }
    removeAllPlayers() {
        for (const id of this.players.keys())this.removePlayer(id);
    }
    connect(profile) {
        this.connections.set(profile.id, profile);
        dispatchEvent(new Event("connections"));
    }
    disconnect(id) {
        this.connections.delete(id);
        dispatchEvent(new Event("connections"));
    }
    updateBlock(update) {
        const { x: x, y: y } = update.position;
        const block = this.blocks[x] && this.blocks[x][y];
        if (!block) return;
        block.update(update);
    }
    updatePlayer(update) {
        const { u: u, i: i } = update;
        const player = this.players.get(u + i);
        if (!player) return;
        player.update(update);
    }
    clear() {
        for(let x = -1; x <= this.size.x; x++)for(let y = -1; y <= this.size.y; y++)this.removeAt(x, y);
    }
    getOwnPlayersDistance() {
        let distance = 0;
        const own_players = this.getOwnPlayers();
        for (const player of own_players)for (const other of own_players){
            if (player === other) continue;
            distance = Math.max(distance, player.position.distance(other.position));
        }
        return distance;
    }
    getOwnPlayersCenter() {
        return Vector2.avg(this.getOwnPlayers().map((plr)=>plr?.position));
    }
    getOwnPlayers() {
        const own_players = [];
        for (const player of this.players.values())if (player.uid === globalThis.STORE.profile.id) own_players.push(player);
        return own_players;
    }
    hasOwnPlayers() {
        for (const player of this.players.values())if (player.uid === globalThis.STORE.profile.id) return true;
    }
    addPlayer(uid, index) {
        this.players.get(uid + index)?.remove();
        let player;
        if (uid === globalThis.STORE.profile.id) {
            const keys = globalThis.PLAYER_CONTROLS[index];
            player = new Player(PlayerConfiguration.ofKeys(...keys, index));
        } else player = new Player({
            index: index,
            remote: true
        });
        this.players.set(uid + index, player);
        this.div.append(player.div);
        dispatchEvent(new CustomEvent("addplayer", {
            detail: [
                uid,
                index
            ]
        }));
    }
    removePlayer(uid, index) {
        this.players.get(uid + index)?.remove();
        this.players.delete(uid + index);
        dispatchEvent(new CustomEvent("removeplayer", {
            detail: [
                uid,
                index
            ]
        }));
    }
    addBlock(block) {
        const { x: x, y: y } = block.position;
        if (this.blocks[x][y]) this.removeBlock(this.blocks[x][y], false);
        this.blocks[x][y] = block;
        this.div.append(block.div);
        if (!this.loading) dispatchEvent(new CustomEvent("addblock", {
            detail: block
        }));
    }
    removeBlock(block, dispatch = true) {
        const { x: x, y: y } = block;
        if (this.blocks[x]) delete this.blocks[x][y];
        block?.remove();
        if (!this.loading && block && dispatch) dispatchEvent(new CustomEvent("removeblock", {
            detail: block
        }));
    }
    removeAt(x, y) {
        const block = this.blocks[x][y];
        delete this.blocks[x][y];
        block?.remove();
        if (!this.loading && block) dispatchEvent(new CustomEvent("removeblock", {
            detail: block
        }));
    }
    setSize(x, y) {
        this.size.x = x;
        this.size.y = y;
        this.ensureBlockBuffers();
        this.cleanBlockBuffers();
        this.renderSize();
        dispatchEvent(new Event("worldsize"));
    }
    ensureBlockBuffers() {
        this.blocks = this.blocks || [];
        for(let i = -1; i <= this.size.x; i++)this.blocks[i] = this.blocks[i] || [];
    }
    cleanBlockBuffers() {
        for(let x = -1; x <= this.size.x; x++){
            const file = this.blocks[x];
            for(let y = this.size.y + 1; y < file.length; y++)this.removeAt(x, y);
        }
        for(let x = this.size.x + 1; x < this.blocks.length; x++){
            const file = this.blocks[x];
            for(let y = -1; y < file.length; y++)this.removeAt(x, y);
        }
    }
    renderSize() {
        this.div.style.setProperty("--size-x", this.size.x);
        this.div.style.setProperty("--size-y", this.size.y);
    }
    increaseScale() {
        this.setScale(this.scale + globalThis.SCALE_STEP);
    }
    decreaseScale() {
        this.setScale(this.scale - globalThis.SCALE_STEP);
    }
    setScale(scale) {
        this.scale = scale;
        this.clipScale();
        this.renderScale();
    }
    clipScale() {
        this.scale = Math.min(this.scale, globalThis.SCALE_MAX);
        this.scale = Math.max(this.scale, globalThis.SCALE_MIN);
    }
    renderScale() {
        this.div.style.setProperty("--scale", this.scale);
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
        this.renderPosition();
    }
    renderPosition() {
        this.div.style.setProperty("--x", this.position.x);
        this.div.style.setProperty("--y", this.position.y);
    }
    toBase64() {
        const rows = [];
        for(let y = -1; y <= this.size.y; y++){
            let row = "";
            for(let x = -1; x <= this.size.x; x++){
                const block = this.blocks[x][y];
                if (block?.index < 64) row += globalThis.BASE64[block.index];
                else row += " ";
            }
            rows.push(row);
        }
        return rows.join("\n");
    }
    applyBase64(data) {
        this.loading = true;
        const base64 = globalThis.BASE64.split("");
        const rows = data.split("\n");
        let width = 0;
        for (const row of rows)width = Math.max(width, row.length);
        this.setSize(width - 2, rows.length - 2);
        for(let y = 0; y < rows.length; y++){
            const row = rows[y];
            for(let x = 0; x < row.length; x++){
                const char = row[x];
                const index = base64.findIndex((c)=>c === char);
                if (index !== -1) this.addBlock(new Block(x - 1, y - 1, index));
                else this.removeAt(x - 1, y - 1);
            }
        }
        this.loading = false;
    }
};


globalThis.ListDialogue = class ListDialogue extends Dialogue {
    constructor(options){
        super({
            title: "Load Save",
            body: "",
            ...options
        });
        this.options = options.options || [];
        this.selected = options.selected;
        this.div.classList.add("list-dialogue");
        this.buttons = {};
        for (const key of this.options){
            const button = document.createElement("button");
            button.innerText = key;
            button.addEventListener("click", ()=>this.select(key), this.abort);
            this.body.append(this.buttons[key] = button);
        }
        this.select(this.selected);
    }
    select(key) {
        if (!this.options.includes(key)) return;
        this.selected = key;
        for (const [savekey, button] of Object.entries(this.buttons))if (savekey === key) button.classList.add("active");
        else button.classList.remove("active");
    }
};


globalThis.SaveForm = class SaveForm extends Dialogue {
    constructor(){
        super({
            title: "Save As",
            body: "Save name:",
            action () {
                if (!this.input.value) return true;
                if (globalThis.STORE.saves[this.input.value]) new Dialogue({
                    body: `Save "${this.input.value}" already exists. Do you want to overwrite it?`,
                    action: ()=>this.save()
                });
                else this.save();
            }
        });
        this.div.id = "save-form";
        this.input = document.createElement("input");
        this.input.placeholder = "...";
        this.input.addEventListener("keydown", cancelbubble, this.abort);
        this.body.append(this.input);
    }
    save() {
        if (!this.input.value) return;
        globalThis.STORE.saveWorldAs(this.input.value);
        if (globalThis.GAME.context === "local") globalThis.ROUTER.goto(`/local/${this.input.value}`);
    }
};


globalThis.Status = class Status {
    constructor(){
        this.abort = new AbortController();
        this.div = document.createElement("div");
        this.div.id = "status";
        this.div.addEventListener("mousedown", globalThis.cancelbubble, this.abort);
        addEventListener("store", this.update.bind(this), this.abort);
        addEventListener("worldsize", this.update.bind(this), this.abort);
        addEventListener("route", this.update.bind(this), this.abort);
        document.body.append(this.div);
        this.update();
    }
    remove() {
        this.abort.abort();
        this.div.remove();
    }
    update() {
        const activeid = globalThis.GAME.id;
        const name = activeid || "<New>";
        let size = "";
        if (globalThis.WORLD) {
            const { x: x, y: y } = globalThis.WORLD.size;
            size = `(${x}x${y})`;
        }
        if (activeid) document.title = `Platfo | ${name}`;
        else document.title = "Platfo";
        this.div.innerText = [
            name,
            size
        ].join(" ");
    }
};


globalThis.Topbar = class Topbar {
    constructor(){
        globalThis.TOPBAR = this;
        this.div = document.createElement("div");
        this.div.id = "topbar";
        this.constructControlButtons();
        this.constructPlayerButtons();
        this.constructStateButtons();
        this.constructListeners();
        document.body.append(this.div);
    }
    constructControlButtons() {
        const div = document.createElement("div");
        this.control = {
            menu: new Icon("MENU"),
            camera: new Icon("CAMERA"),
            pen: new Icon("PEN")
        };
        div.append(...Object.values(this.control).map((icon)=>icon.div));
        this.div.append(div);
    }
    constructPlayerButtons() {
        const div = document.createElement("div");
        this.players = [];
        for(let i = 0; i < 3; i++){
            const plr = document.createElement("div");
            plr.classList.add("player", "color" + i);
            plr.addEventListener("click", this.onPlayerClick.bind(this));
            div.append(this.players[i] = plr);
        }
        this.div.append(div);
    }
    constructStateButtons() {
        const div = document.createElement("div");
        this.state = {
            cameralock: new Icon("CAMERALOCK"),
            debug: new Icon("DEBUG")
        };
        div.append(...Object.values(this.state).map((icon)=>icon.div));
        this.div.append(div);
    }
    constructListeners() {
        this.abort = new AbortController();
        addEventListener("keydown", this.onKeydown.bind(this), this.abort);
        addEventListener("addplayer", this.onAddPlayer.bind(this), this.abort);
        addEventListener("removeplayer", this.onRemovePlayer.bind(this), this.abort);
        this.div.addEventListener("mousedown", globalThis.cancelbubble, this.abort);
        this.constructControlListeners();
        this.constructStateListeners();
        addEventListener("store", this.onStore.bind(this), this.abort);
    }
    constructControlListeners() {
        for (const [key, icon] of Object.entries(this.control))icon.div.addEventListener("click", ()=>{
            if (!this.hasControl(key)) {
                if (key !== "menu") this.clearControl();
                this.addControl(key);
            } else this.removeControl(key);
        }, this.abort);
    }
    constructStateListeners() {
        for (const [detail, icon] of Object.entries(this.state)){
            icon.div.addEventListener("click", ()=>globalThis.STORE.setProp(detail, !globalThis.STORE[detail]), this.abort);
            this.onStore({
                detail: detail
            });
        }
    }
    onStore(event) {
        const key = event.detail;
        if (!Object.keys(this.state).includes(key)) return;
        const value = globalThis.STORE[key];
        if (value) this.addState(key);
        else this.removeState(key);
    }
    remove() {
        this.div.remove();
        this.abort.abort();
        delete globalThis.TOPBAR;
    }
    onKeydown(event) {
        if (event.ctrlKey || event.altKey || event.metaKey) return;
        for(let i = 0; i < globalThis.PLAYER_CONTROLS.length; i++){
            const keys = globalThis.PLAYER_CONTROLS[i];
            if (keys.includes(event.keyCode)) return globalThis.CLIENT.addPlayer(i);
        }
        switch(event.keyCode){
            case 192:
                this.toggleControl("menu");
                break;
            case 49:
                this.toggleControl("camera");
                break;
            case 50:
                this.toggleControl("pen");
                break;
        }
    }
    toggleControl(name) {
        if (this.hasControl(name)) this.removeControl(name);
        else {
            if (name !== "menu") this.clearControl();
            this.addControl(name);
        }
    }
    clearControl() {
        for (const control_name of Object.keys(this.control))this.removeControl(control_name);
    }
    addControl(name) {
        if (this.hasControl(name)) return;
        this.control[name]?.div.classList.add("active");
        document.body.classList.add(name);
        dispatchEvent(new CustomEvent("addcontrol", {
            detail: name
        }));
    }
    removeControl(name) {
        if (!this.hasControl(name)) return;
        this.control[name]?.div.classList.remove("active");
        document.body.classList.remove(name);
        dispatchEvent(new CustomEvent("removecontrol", {
            detail: name
        }));
    }
    hasControl(name) {
        return this.control[name]?.div.classList.contains("active");
    }
    addState(name) {
        this.state[name]?.div.classList.add("active");
        document.body.classList.add(name);
    }
    removeState(name) {
        this.state[name]?.div.classList.remove("active");
        document.body.classList.remove(name);
    }
    hasState(name) {
        return this.state[name]?.div.classList.contains("active");
    }
    onPlayerClick(event) {
        const uid = globalThis.STORE.profile.id;
        const index = this.players.findIndex((d)=>d === event.target);
        if (globalThis.WORLD.players.get(uid + index)) globalThis.CLIENT.removePlayer(index);
        else globalThis.CLIENT.addPlayer(index);
    }
    onAddPlayer(event) {
        const [uid, index] = event.detail;
        if (uid !== globalThis.STORE.profile.id) return;
        this.players[index].classList.add("active");
    }
    onRemovePlayer(event) {
        const [uid, index] = event.detail;
        if (uid !== globalThis.STORE.profile.id) return;
        this.players[index].classList.remove("active");
    }
};


globalThis.BlockSelector = class BlockSelector extends Card {
    constructor(){
        super({
            closable: false
        });
        this.abort = new AbortController();
        this.div.id = "block-selector";
        this.title.innerText = "Blocks";
        this.index = 0;
        this.blocks = [];
        for(let i = 0; i < globalThis.BLOCKS; i++){
            const block = Block.of(i);
            block.div.addEventListener("click", ()=>{
                this.index = i;
                this.renderActive();
            }, this.abort);
            this.content.append(block.div);
            this.blocks.push(block);
        }
        this.renderActive();
        this.centerY();
    }
    remove() {
        super.remove();
    }
    renderActive() {
        for(let i = 0; i < globalThis.BLOCKS; i++){
            const block = this.blocks[i];
            if (i === this.index) block.div.classList.add("active");
            else block.div.classList.remove("active");
        }
    }
};


addEventListener("load", ()=>{
    new Store();
    new Router({
        "^/$": Browser,
        "^/(local|ws|wss)/(.*)": Game
    });
});


//# sourceMappingURL=index.33d10550.js.map
